import Icon from "@ant-design/icons"

const SolidLineSvg = () => {
  return (
    <svg viewBox='0 0 100 100'>
      <g>
        <line strokeWidth='4' stroke='#000' id='svg_1' y2='10' x2='92' y1='91.875' x1='10' fill='none' />
      </g>
    </svg>
  )
}
export const SolidLineIcon = (props: any) => <Icon component={SolidLineSvg} {...props} />